import routerOptions0 from "/runner/_work/nova-widget/nova-widget/node_modules/.pnpm/nuxt@3.5.2_@types+node@18.17.1_eslint@8.45.0_sass@1.64.1_stylelint@15.10.2_typescript@5.1.6_vue-tsc@2.0.7/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions0,
}